module.exports = __webpack_public_path__ + "img/nota-folio-firma.90746fa7.png";